<script lang="ts">
  import { onMount } from 'svelte'
  import { get } from 'svelte/store'
  import { pageStore, fn } from '@packages/stores'
  import { ScanTypes } from '@packages/utils/enums'
  import { once, PassportEvents } from '@lib/events/events'
  import {
    goToPayment,
    goToSendTokens,
    processAirDrop,
    processRequestLoyaltyPoints,
  } from '@pages/scanner/Scanner.service'
  import {
    SCANNER_TARGET_ID,
    createScanner,
    getScannerErrorMessage,
    setupScanner,
    type ScannerLib,
  } from '@lib/scanner'
  import {Scanner as ScannerComponent} from '@packages/ui'
  import { getUserAddressBySub } from '@src/Passport.service'
  import { parseUpcCodeAndGetValue } from '@lib/keyVal'
  import { configStore } from '@src/stores'
  import { toastAlert } from '@src/passport/ui'
  import { NOT_VALID_PASSPORT_QR_CODE_MESSAGE } from '@packages/utils/constants'

  const { close } = get(fn)
  let scanner: ScannerLib
  let isScannerLoaded = false

  const onCapture = async ({ message, sub, scanType }: { sub: string; message: string; scanType: string }) => {
    if (!scanType) {
      try {
        const config = get(configStore);
        [scanType, message] = await parseUpcCodeAndGetValue(message, config.clientId)
      } catch {
        toastAlert(NOT_VALID_PASSPORT_QR_CODE_MESSAGE(message), 'failure')
        return scanner.close()
      }
    }
    scanner.close()
    switch (scanType) {
      case ScanTypes.PASSPORT_ID_PASS:
      case ScanTypes.PASSPORT_ID: {
        const parsed = JSON.parse(message)
        const { address } = await getUserAddressBySub(sub)
        goToSendTokens({ userAddress: address, amount: parsed?.amount })
        break
      }
      case ScanTypes.TOKENS_PURCHASE: {
        goToPayment(JSON.parse(message))
        break
      }
      case ScanTypes.AIR_DROP_ASSET: {
        await processAirDrop(JSON.parse(message))
        break
      }
      case ScanTypes.REQUEST_LOYALTY_POINTS: {
        await processRequestLoyaltyPoints(JSON.parse(message))
        break
      }
      default: {
        close()
        pageStore.set(null)
      }
    }
  }

  onMount(async () => {
    const { scanner: scannerInstance, events } = await createScanner(SCANNER_TARGET_ID)
    scanner = scannerInstance
    once(PassportEvents.UI_CLOSED, () => {
      scanner.close()
      pageStore.set(null)
    })
    setupScanner<{ message: string; sub: string; scanType: string }>(scanner, events, {
      onCapture,
      onError: (err) => {
        const message = getScannerErrorMessage(err)
        if (message?.includes('Permission'))
          alert('In order to scan please allow the current page to access your camera and try again.')
      },
    })
    isScannerLoaded = true
    await scanner.scan({ isCloseButton: false })
  })
</script>

<ScannerComponent options={{ isScannerLoaded }} />
